<template>
  <section
    class="hero"
    :style="heroBackgroundStyle"
    aria-label="Rosetta 3D hero"
  >
    <div class="hero-content">
      <div class="hero-logos" aria-label="Partner logos">
        <img
          :src="baseUrl + 'site-assets/RepubliqueFR.png'"
          alt="Republique Française logo"
        >
        <img :src="baseUrl + 'site-assets/logo-cnes-blanc-header.png'" alt="CNES logo">
        <img :src="baseUrl + 'site-assets/LAM.png'" alt="LAM logo">
        <img :src="baseUrl + 'site-assets/LATMOS-white.png'" alt="LATMOS logo">
      </div>
      <div class="hero-text">
        <h2>Welcome to 3D view of Rosetta Comet</h2>
        <p>Explore spatial data interactively.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {
    heroBackgroundStyle() {
      const imageUrl = `${process.env.BASE_URL}site-assets/3D_View_Rosetta2.jpg`;
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: "right center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "auto 100%",
      };
    },
  },
};
</script>

<style scoped lang="scss">
.hero {
  width: calc(100% + 30px);
  height: 280px;
  max-height: 280px;
  overflow: hidden;
  background-color: #000000;
  display: flex;
  align-items: stretch;
  margin-left: -15px;
  position: relative;
}

.hero-content {
  width: 66.6667%;
  height: 100%;
  padding: 1.5rem 15px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  color: #ffffff;
  gap: 2.5rem;
  position: relative;
  z-index: 1;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.7) 50%
  );
}

.hero-text {
  margin: 0;
  transform: translateY(6px);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.hero-text h2 {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
  color: white !important;
}

.hero-text p {
  font-size: 1.4rem;
  margin: 0;
  color: white;
}

.hero-logos {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2.5rem;
  align-items: center;
}

.hero-logos img {
  max-height: 90px;
  width: auto;
  object-fit: contain;
}

@media (max-width: 900px) {
  .hero {
    min-width: 360px;
    background-size: cover;
    background-position: center center;
  }

  .hero-content {
    width: 100%;
    padding: 1.5rem;
  }

  .hero-logos {
    width: 100%;
    display: flex;
    gap: 1rem;
    flex-wrap: nowrap;
    align-items: center;
  }

  .hero-logos img {
    max-height: 50px;
    width: auto;
    object-fit: contain;
  }
}

@media (max-width: 1200px) {
  .hero-logos img {
    max-height: 70px;
  }
}
</style>
